<template>
  <div class="fade-in">
    <Camera
      headerText="Tire a foto da frente do seu documento (sem plástico)"
      onBackGoTo="onboarding-frontdoc-step"
      @sendImg="handleImg"
    />
  </div>
</template>

<script>
import Camera from '../components/Camera.vue';

export default {
  name: 'onboarding-frontdoc-camera',
  components: { Camera },
  data: () => ({
    cameraOn: false,
    isSelfie: null,
  }),
  methods: {
    async handleImg(img) {
      this.$emit('sendImage', { img, step: 'frontdoc' });
    },
  },
};
</script>
